function unwrapRef(maybeRef) {
  return typeof maybeRef === 'object' && 'current' in maybeRef ? maybeRef.current : maybeRef;
}
export default unwrapRef;